export interface Menu {
  menuGroupId: string;
  menuGroupName: string;
  menuGroupType: string;
  read?: boolean;
  menus: MenuItem[];
}
export interface MenuItem {
  id: string;
  name: string;
  chkTtls?: MenuItemChild[];
  ctype?: string | null;
  action?: string | null;
  read?: boolean;
  write?: boolean;
  path?: string;
}
export interface MenuItemChild {
  objcd: string;
  ttlkbn: string;
  ttlcd: string;
  name: string;
  path: string;
}

export enum KidsMenuName {
  DAILY = '1日の予定',
  SCHEDULE = '全体の予定',
  // CALENDAR = '月間予定',
  CALENDAR_USER = '利用者の月間予定',
  CALENDAR_STAFF = '職員の月間予定',
  BOARD = '掲示板'
}

export const homeGroup = {
  menuGroupId: '',
  menuGroupName: 'ホーム',
  menuGroupType: '',
  menus: [
    { id: '', name: KidsMenuName.DAILY, path: '/home/daily' },
    // { id: '', name: '予定追加', edit: 'schedule-select' },
{ id: '', name: KidsMenuName.SCHEDULE, path: '/home/schedule' },
    { id: '', name: KidsMenuName.CALENDAR_STAFF, path: '/home/calendar/staffs' },
    { id: '', name: KidsMenuName.CALENDAR_USER, path: '/home/calendar/users' },
    { id: '', name: KidsMenuName.BOARD, path: '/home/board' },
  ],
};

export const webviewHomeGroup = {
  ...homeGroup,
  menuGroupName: '予定・掲示板',
  menus: homeGroup.menus
    .filter((menu) => [KidsMenuName.SCHEDULE, KidsMenuName.CALENDAR_USER, KidsMenuName.CALENDAR_STAFF, KidsMenuName.BOARD].includes(menu.name))
    .map((menu) => {
      return menu.path ? { ...menu, path: `/webview${menu.path}` } : menu;
    }),
};

export const webviewSettingGroup = {
  menuGroupId: '',
  menuGroupName: '設定',
  menuGroupType: '',
  menus: [{ id: '', name: 'エイリアス設定', modal: 'webview-alias-select' }],
};
